import React from "react";
import { CreateProductType } from "../../types";
import EditDropdown from "../EditComponents/EditDropdown";
import EditSubmitButton from "../EditComponents/EditSubmitButton";

const BasicIinformationForm = ({
  setActive,
  active,
  handleInputChange,
  payload,
  setPayload,
  edit,
  handleSubmit,
  validity,
  isLoading,
}: {
  setActive: any;
  active: number;
  handleInputChange: any;
  payload: CreateProductType;
  setPayload: React.Dispatch<React.SetStateAction<CreateProductType>>;
  edit?: boolean;
  handleSubmit: any;
  validity: any;
  isLoading: any;
}) => {
  return (
    <div className="mx-auto max-w-[700px] border-[1px] border-[#eeeeee] rounded-[10px] mt-[20px]">
      <div className="p-[20px] font-medium border-b-[1px] border-[#eeeeee]">
        Basic Information
      </div>
      <div className="p-[20px]">
        <label htmlFor="name" className="mt-[30px] text-grey">
          Product Name
        </label>
        <input
          name="name"
          type="text"
          placeholder="Product Name"
          onChange={handleInputChange}
          value={payload?.name}
          className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
        />
        <div className="">
          {/* <div className="w-6/12"> */}
          <label htmlFor="categories" className="mt-[30px] text-grey">
            Product Category
          </label>
          <div>
            <EditDropdown
              placeholder={"--Select Categories--"}
              payload={payload}
              setPayload={setPayload}
            />
            <div>
              <div className="bg-grey text-center rounded-full p-[4px] text-white text-[12px]">
                Selected Options
              </div>
              <div className="relative mt-3 flex gap-2 flex-nowrap overflow-x-scroll border-[1px] border-[#d3d3d3] rounded-md p-2">
                {payload?.categories?.map((category: any) => (
                  <button
                    key={category.id}
                    className="text-[14px] p-2 bg-primary-light rounded-md min-w-[160px]"
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
          {/* </div> */}
          {/* <div className="w-6/12">
            <label htmlFor="brandName" className="mt-[30px] text-grey">
              Brand
            </label>
            <input
              name="brandName"
              type="text"
              value={payload?.brandName}
              onChange={handleInputChange}
              placeholder="Brand Name"
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div> */}
        </div>
        <div className="mt-3">
          <label htmlFor="brandName" className="mt-[30px] text-grey">
            Brand
          </label>
          <input
            name="brandName"
            type="text"
            value={payload?.brandName}
            onChange={handleInputChange}
            placeholder="Brand Name"
            className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
          />
        </div>
        <div className="flex gap-2 mt-3">
          <div className="w-6/12">
            <label htmlFor="unitPrice" className="mt-[30px] text-grey">
              Unit Price
            </label>
            <input
              type="text"
              name="unitPrice"
              value={
                payload?.unitPrice
                  ? Number(payload.unitPrice).toLocaleString()
                  : ""
              }
              onChange={(e) => {
                const rawValue = e.target.value.replace(/,/g, "");
                if (!isNaN(Number(rawValue))) {
                  setPayload((prev) => ({ ...prev, unitPrice: rawValue }));
                }
              }}
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
          <div className="w-6/12">
            <label htmlFor="bulkPrice" className="mt-[30px] text-grey">
              Bulk Price
            </label>

            <input
              type="text"
              name="bulkPrice"
              value={
                payload?.bulkPrice
                  ? Number(payload.bulkPrice).toLocaleString()
                  : ""
              }
              onChange={(e) => {
                const rawValue = e.target.value.replace(/,/g, "");
                if (!isNaN(Number(rawValue))) {
                  setPayload((prev) => ({ ...prev, bulkPrice: rawValue }));
                }
              }}
              className="px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
            />
          </div>
        </div>
        <div className="">
          <label htmlFor="description" className="mt-[30px] text-grey">
            Product description
          </label>
          <textarea
            name="description"
            value={payload?.description}
            onChange={handleInputChange}
            placeholder="Product description"
            className="resize-none h-[300px] px-6 py-4 bg-white mt-[13px] mb-[25px] w-full border-[1px] ease-in-out duration-300 border-[#d3d3d3] focus:border-orange rounded-md"
          />
        </div>
        <div className="flex gap-x-3">
          <div className="w-6/12">
            <button
              disabled={isLoading}
              className="text-orange bg-primary-light p-[16px] w-full font-bold rounded-md ease-in-out duration-300"
              onClick={() => setActive(active + 1)}
            >
              Next
            </button>
          </div>
          <div className="w-6/12">
            <EditSubmitButton
              handleSubmit={handleSubmit}
              validity={validity}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicIinformationForm;
